var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ts-menu-item",class:{ 'has-icon': _vm.hasIcon }},[_c('router-link',{class:{ exact: _vm.exact },attrs:{"to":_vm.to}},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }